import { useEffect, useState } from "react";
import { Content, SubContent, Main } from "../../../components/Layout";
import style from "../style.module.css";
import MenuTrainee from "../../../components/MenuTrainee";
import { Row, Col } from "react-bootstrap";
import api from "../../../services/api";
import useWrapper from "../../../hooks/useWrapper";
import TableResponsive from "../../../components/TableResponsive";
import useFormat from "../../../hooks/utils/useFormat";
import StatusFlag from "../../../components/StatusFlag";
import { toast } from "react-toastify";
import Tooltip2 from "../../../components/Tooltip";
import MeusDadosIco from "../../../components/Svg/new/meus-dados";

export default function Formandos() {
  const { me, config } = useWrapper();
  const { formatPhone } = useFormat();

  const [loading, setloading] = useState();
  const [trainees, settrainees] = useState();
  useEffect(() => {
    if (me && !trainees) {
      (async () => {
        setloading(true);

        try {
          const { data: _trainees } = await api.get(
            `/trainee/trainees?joins=null&commercial_id=${me?.commercial_id}&paginate=false`,
            config,
          );

          settrainees(
            _trainees?.map(__trainee => ({
              name: __trainee.name,
              cell: __trainee.cell,
              email: __trainee.email,
              access: !__trainee?.active
                ? "Revogado"
                : !__trainee?.approve_by_team
                ? "Aguardando Aprovação"
                : !__trainee?.aceite_virtual
                ? "Aguardando Aceite"
                : !!__trainee?.aceite_virtual
                ? "Autorizado"
                : "?",
              bond: !__trainee?.cancel ? "Ativo" : "Encerrado",
              is_member: !!__trainee?.is_member,
            })),
          );
        } catch (__err) {
          toast.error("Ocorreu algum problema ao tentar carregar a Lista de Formandos.");
          console.log("__err", __err);
        }
        setloading(false);
      })();
    }
  }, [me]);

  return (
    <Main className={style.mainUser}>
      <Content noBG="true">
        <Row>
          <Col md={12} lg={2}>
            <MenuTrainee />
          </Col>
          <Col>
            <SubContent>
              <h2 className="form-title mb-4">Lista de Formandos</h2>
              <TableResponsive
                table={{
                  head: [
                    { data: "Formando" },
                    { data: "Contato" },
                    { data: <div className="text-end">Financeiro</div> },
                    { data: <div className="text-end">Acesso</div> },
                    { data: <div className="text-end">Vínculo</div> },
                  ],
                  loading: loading,
                  body:
                    trainees?.map(__trainee => ({
                      disabled: __trainee?.bond === "Encerrado",
                      data: [
                        {
                          element: (
                            <>
                              {__trainee.is_member ? (
                                <span className="smaller-ico">
                                  <MeusDadosIco />
                                </span>
                              ) : (
                                ""
                              )}
                              {__trainee.name}
                            </>
                          ),
                        },
                        {
                          element: (
                            <>
                              <p className="m-0">{__trainee.email}</p>
                              <p className="m-0">{formatPhone(__trainee.cell)}</p>
                            </>
                          ),
                        },
                        {
                          element: (
                            <div className="text-end">
                              <StatusFlag status={!__trainee?.financial_released ? "Sem Financeiro" : "Criado"} />
                            </div>
                          ),
                        },
                        {
                          element: (
                            <div className="text-end">
                              <StatusFlag status={__trainee?.access || "?"} />
                            </div>
                          ),
                        },
                        {
                          element: (
                            <div className="text-end">
                              <StatusFlag status={__trainee?.bond || "?"} />
                            </div>
                          ),
                        },
                      ],
                    })) || [],
                }}
              />
            </SubContent>
          </Col>
        </Row>
      </Content>
    </Main>
  );
}
